import { CalendarDays } from 'lucide-react'

export default function BlogChangelogTeaser() {
  const items = [
    {
      date: '2025-09-15',
      title: 'Cập nhật nền tảng: hiệu năng & trải nghiệm',
      description: 'Cải thiện tốc độ tải, tối ưu lịch thi đấu real-time và cập nhật giao diện.'
    },
    {
      date: '2025-08-01',
      title: 'Ra mắt tính năng xác thực thành viên',
      description: 'Thêm module mã xác thực giúp đảm bảo quyền truy cập cho thành viên.'
    },
  ]

  return (
    <section id="changelog" className="py-20 bg-gradient-to-b from-neutral-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-mebi-yellow-100 rounded-full mb-6">
              <CalendarDays className="w-4 h-4 text-mebi-yellow-600 mr-2" />
              <span className="text-sm font-medium text-mebi-yellow-700">Changelog & Blog</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900">Cập nhật mới nhất</h2>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">Theo dõi các cải tiến và thông báo quan trọng từ MeBi</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {items.map((item, i) => (
              <div key={i} className="rounded-2xl border border-neutral-200 bg-white p-6">
                <p className="text-sm text-neutral-600 mb-2">{item.date}</p>
                <h3 className="text-xl font-bold text-neutral-900 mb-2">{item.title}</h3>
                <p className="text-neutral-700">{item.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a href="#" className="text-mebi-yellow-700 font-semibold hover:underline">Xem tất cả bài viết</a>
          </div>
        </div>
      </div>
    </section>
  )
}